import { useCallback } from 'react'

import { InfiniteData } from '@tanstack/react-query'

import { PaginatedResponse } from '@/types/Api'
import { UUID } from '@/types/Id'
import { Tag } from '@/types/Tag'

import { useTags } from './useTags'

interface UseTagArgs {
  orgId: UUID | ''
  tagId: UUID
}

export const useTag = ({ orgId, tagId }: UseTagArgs) => {
  const select = useCallback(
    (data: InfiniteData<PaginatedResponse<Tag>>) => {
      return data.pages
        .map((page) => page.data)
        .flat()
        .find((tag) => tag.id === tagId)
    },
    [tagId],
  )
  return useTags({ orgId, tagType: null, selector: select })
}
